// @flow

// don't use for conditional requiring files
export const isBrowser = process.env.IS_BROWSER === '1';
export const isElectron = process.env.IS_ELECTRON === '1';
export const isReactNative = process.env.IS_REACT_NATIVE === '1';
export const isClient = isBrowser || isElectron || isReactNative;
